module.exports = "//static.hsappstatic.net/audio-components/static-1.3147/assets/voice-samples/shimmer.mp3"